import { DatePicker, Form, Input, type FormInstance } from "antd";
import { disablePastDates } from "../../../../utils/time.utils";

interface BasicInfoProps {
  disabled?: boolean;
  form: FormInstance<any>;
}
// Test comment

const BasicInfo = ({ disabled, form }: BasicInfoProps) => {
  return (
    <div className="p-6 bg-white rounded-lg border border-gray-100 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Basic Information
      </h3>

      <div className="space-y-4">
        <Form.Item
          label="Campaign Title"
          name="title"
          rules={[{ required: true, message: "Please enter campaign title" }]}
        >
          <Input placeholder="e.g., New Year Sale 2024" disabled={disabled} />
        </Form.Item>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: "Please select start date" }]}
          >
            <DatePicker
              className="w-full"
              placeholder="Select start date"
              disabled={disabled}
              disabledDate={disablePastDates}
              showNow={false}
            />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            dependencies={["startDate"]}
            rules={[
              { required: true, message: "Please select end date" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue("startDate");
                  if (!value || !startDate) {
                    return Promise.resolve();
                  }
                  if (value.isBefore(startDate, "day")) {
                    return Promise.reject(
                      new Error("End date cannot be before start date"),
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker
              className="w-full"
              placeholder="Select end date"
              disabled={disabled}
              disabledDate={(current) => {
                const startDate = form.getFieldValue("startDate");
                if (
                  startDate &&
                  current &&
                  current.isBefore(startDate, "day")
                ) {
                  return true;
                }
                return disablePastDates(current);
              }}
              showNow={false}
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
